import { render, staticRenderFns } from "./QuoteVehicle.vue?vue&type=template&id=385c0ef4&scoped=true"
import script from "./QuoteVehicle.vue?vue&type=script&lang=js"
export * from "./QuoteVehicle.vue?vue&type=script&lang=js"
import style0 from "./QuoteVehicle.vue?vue&type=style&index=0&id=385c0ef4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385c0ef4",
  null
  
)

export default component.exports